module.exports = __webpack_public_path__ + "img/imgProduct01.75e831f3.jpg";